<template>
<div>
    <div class="ml-4" flat color="transparent">
            <v-layout>
                <v-flex xs2>
                    <v-btn :color="page ? 'primary' : ''" flat round @click="pageSettings">Connect to Page</v-btn>
                </v-flex>
                <!-- <v-flex xs1>
                    <v-btn :color="menu ? 'primary' : ''" flat round @click="menuSettings">Menu</v-btn>
                </v-flex> 
                 <v-flex xs2>
                    <v-btn :color="gnote ? 'primary' : ''" flat round @click="gnoteSettings">GetStarted note</v-btn>
                </v-flex>
                 <v-flex xs2>
                    <v-btn :color="wlisting ? 'primary' : ''" flat round @click="wlistingSettings">Whitelistings</v-btn>
                </v-flex>
                <v-flex xs2>
                    <v-btn :color="publish ? 'primary' : ''" flat round @click="publishSettings">Publish bot</v-btn>
                </v-flex>     -->
            </v-layout>
    </div>
    <page v-if="page"> </page>
    <menu1 v-if="menu"> </menu1>
    <gnote v-if="gnote"> </gnote>
    <wlisting v-if="wlisting"> </wlisting>
    <!-- <publish v-if="publish"> </publish> -->
</div>
</template>

<script>
import page from './Display-settings-page.vue'
import menu1 from './Display-settings-menu.vue'
import gnote from './Display-settings-gnote.vue'
import wlisting from './Display-settings-wlisting.vue'
// import publish from './Display-settings-publish.vue'
export default {
    components:{
        page,
        menu1,
        gnote,
        wlisting
    },
    data(){
        return{
            page:true,
            menu:false,
            gnote:false,
            wlisting:false,
            publish:false
        }
    },
    methods:{
        pageSettings(){
            this.page = true
            this.menu = false
            this.gnote = false
            this.wlisting = false
            this.publish = false
        },
        menuSettings(){
            this.page = false
            this.menu = true
            this.gnote = false
            this.wlisting = false
            this.publish = false
        },
        gnoteSettings(){
            this.page = false
            this.menu = false
            this.gnote = true
            this.wlisting = false
            this.publish = false
        },
        wlistingSettings(){
            this.page = false
            this.menu = false
            this.gnote = false
            this.wlisting = true
            this.publish = false            
        },
        publishSettings(){
            this.page = false
            this.menu = false
            this.gnote = false
            this.wlisting = false
            this.publish = true            
        },
        
    },
    created(){
          
    }    
}
</script>
